module.exports = __webpack_public_path__ + "static/img/2673_phase_function_Paper_PointsHejduk_Prediction.9bf77fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2673_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /bMv
// module chunks = 0